import { IconCircle } from "@/components/pieces/IconCircle";
import { EvaluationCriterionFieldsFragment } from "@/graphql";

interface EvaluationCriteriaCardSimpleProps {
  criterion: EvaluationCriterionFieldsFragment;
}

export function EvaluationCriteriaCardSimple({
  criterion,
}: EvaluationCriteriaCardSimpleProps) {
  return (
    <div className="border-border rounded-lg border bg-white p-6">
      <div className="mb-2 text-lg font-semibold break-words">
        {criterion.name}
      </div>
      <div className="mt-3 flex flex-col gap-4">
        {criterion?.items?.map((item) => (
          <div key={item?.id} className="flex items-start">
            <IconCircle
              icon="tick"
              backgroundColor="#D3F2E5"
              color="#0D8050"
              size={24}
              iconSize={14}
            />
            <div className="ml-3 flex-1">{item?.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
